/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

export default angular.module('tektelic.api.integration', [])
    .factory('integrationService', IntegrationService)
    .name;

/*@ngInject*/
function IntegrationService($http, $q) {

    var service = {
        deleteIntegration: deleteIntegration,
        getIntegration: getIntegration,
        saveIntegration: saveIntegration,
        getApplicationIntegrations: getApplicationIntegrations,
        getIntegrationHttpEndpointLink: getIntegrationHttpEndpointLink
    }

    return service;

    function getApplicationIntegrations (applicationId) {
        var deferred = $q.defer();
        $http.get(`/api/application/${applicationId}/integrations`, null).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function getIntegration (integrationId) {
        var deferred = $q.defer();
        var url = '/api/integration/' + integrationId;
        $http.get(url, null).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function saveIntegration (integration) {
        var deferred = $q.defer();
        var url = '/api/integration';
        $http.post(url, integration).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function deleteIntegration (integrationId) {
        var deferred = $q.defer();
        var url = '/api/integration/' + integrationId;
        $http.delete(url).then(function success() {
            deferred.resolve();
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function getIntegrationHttpEndpointLink(configuration, integrationType, routingKey) {
        var type = integrationType ? integrationType.toLowerCase() : '';
        var key = routingKey ? routingKey : '';
        return `/api/v1/integration/${type}/${key}`;
    }

}



// WEBPACK FOOTER //
// ./src/app/api/integration.service.js